var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJiraAbleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4686 2.27539H7.70508C7.70508 2.96535 7.97916 3.62705 8.46704 4.11493C8.95492 4.6028 9.61662 4.87689 10.3066 4.87689H11.3686V5.90189C11.369 6.59133 11.643 7.25242 12.1305 7.73993C12.618 8.22744 13.2791 8.50149 13.9686 8.50189V2.77539C13.9686 2.64278 13.9159 2.51561 13.8221 2.42184C13.7284 2.32807 13.6012 2.27539 13.4686 2.27539Z",
    fill: "#2684FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6165 5.14648H4.85352C4.85391 5.83593 5.12797 6.49701 5.61548 6.98452C6.10299 7.47203 6.76407 7.74609 7.45352 7.74648H8.51502V8.77498C8.51581 9.46443 8.79025 10.1254 9.27804 10.6126C9.76583 11.0998 10.4271 11.3735 11.1165 11.3735V5.64648C11.1165 5.51388 11.0638 5.3867 10.9701 5.29293C10.8763 5.19916 10.7491 5.14648 10.6165 5.14648Z",
    fill: "url(#paint0_linear_26700_62139)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7635 8.01758H2C1.99993 8.35925 2.06718 8.6976 2.19788 9.01328C2.32859 9.32897 2.52021 9.61582 2.76179 9.85744C3.00336 10.0991 3.29017 10.2907 3.60583 10.4215C3.92149 10.5523 4.25982 10.6196 4.6015 10.6196H5.6665V11.6446C5.6669 12.3335 5.94054 12.9941 6.4274 13.4816C6.91426 13.969 7.57458 14.2434 8.2635 14.2446V8.51758C8.2635 8.38497 8.21082 8.25779 8.11705 8.16403C8.02328 8.07026 7.89611 8.01758 7.7635 8.01758Z",
    fill: "url(#paint1_linear_26700_62139)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26700_62139",
    x1: 9.72152,
    y1: 3.93798,
    x2: 7.28502,
    y2: 6.48048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26700_62139",
    x1: 184.415,
    y1: 171.246,
    x2: 79.7275,
    y2: 274.849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJiraAbleIcon);
export default __webpack_public_path__ + "static/media/jiraAbleIcon.bbd81f9d94cfbbff355466ec08c5d19e.svg";
export { ForwardRef as ReactComponent };